import { Box, Heading, Text, UnorderedList, ListItem, Link } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import routes from 'constants/routes';
import { pageview } from 'utils/analytics';

const RafflesRulesPage = () => {
  useEffect(() => {
    pageview(routes.raffleRules);
  }, []);

  return (
    <Box maxWidth="800px" mx="auto">
      <Heading as="h1" color="#78BEFF" fontWeight="800" fontSize="32px" textAlign="center" mb={8}>
        Weekly Raffles Rules
      </Heading>

      <Box mb={8}>
        <Heading
          as="h2"
          fontSize="18px"
          fontWeight="700"
          opacity="0.8"
          color="var(--chakra-colors-blue)"
          textAlign="center"
          textTransform="uppercase"
          mb={4}
        >
          Who?
        </Heading>
        <UnorderedList>
          <ListItem>
            <Text fontSize="16px" fontWeight="700">
              Only{' '}
              <Link as={RouterLink} to={routes.rewards} color="var(--chakra-colors-blue)">
                premium
              </Link>{' '}
              subscribers are entered
            </Text>
          </ListItem>
        </UnorderedList>
      </Box>

      <Box mb={8}>
        <Heading
          as="h2"
          fontSize="18px"
          fontWeight="700"
          opacity="0.8"
          color="var(--chakra-colors-blue)"
          textAlign="center"
          textTransform="uppercase"
          mb={4}
        >
          How?
        </Heading>
        <UnorderedList>
          <ListItem>
            <Text fontSize="16px" fontWeight="700">
              All premium subscribers are automatically entered and have an equal random chance to win
            </Text>
          </ListItem>
        </UnorderedList>
      </Box>

      <Box mb={8}>
        <Heading
          as="h2"
          fontSize="18px"
          fontWeight="700"
          opacity="0.8"
          color="var(--chakra-colors-blue)"
          textAlign="center"
          textTransform="uppercase"
          mb={4}
        >
          When?
        </Heading>
        <UnorderedList>
          <ListItem>
            {' '}
            <Text fontSize="16px" fontWeight="700">
              Raffles are drawn live on the 5 Card Draw Instagram every Monday at 6pm ET
            </Text>
          </ListItem>
        </UnorderedList>
      </Box>

      <Box mb={8}>
        <Heading
          as="h2"
          fontSize="18px"
          fontWeight="700"
          opacity="0.8"
          color="var(--chakra-colors-blue)"
          textAlign="center"
          textTransform="uppercase"
          mb={4}
        >
          What?
        </Heading>
        <UnorderedList>
          <ListItem>
            <Text fontSize="16px" fontWeight="700">
              Raffles prizes change weekly and are displayed under your daily hand
            </Text>
          </ListItem>
          <ListItem>
            <Text fontSize="16px" fontWeight="700" mt={6}>
              Entrants must be at least 13 years old to become eligible for a win. Entry is subject to all applicable
              laws. See our Sweepstakes Official Rules{' '}
              <Box as={RouterLink} to={routes.rules} color="var(--chakra-colors-blue)">
                FULL SWEEPSTAKES OFFICIAL RULES
              </Box>{' '}
              for more details.
            </Text>
          </ListItem>
        </UnorderedList>
      </Box>
    </Box>
  );
};

export default RafflesRulesPage;
